/**
 * Gemensam byggare av länkar till sparade dokument.
 * Alla vyer använder den här så att projekt-, mapp- och dokument-id
 * alltid följer med – annars uppstår "ID-fel" när dokumentet öppnas.
 */
export type DocumentKind = "risk_assessment" | "skr_assessment" | "work_preparation";

export interface DocumentRouteInput {
  projectId?: string | null;
  folderId?: string | null;
  assessmentId?: string | null;
  type?: DocumentKind | string;
}

export function buildDocumentRoute({
  projectId,
  folderId,
  assessmentId,
  type,
}: DocumentRouteInput): string | null {
  if (!projectId || !folderId || !assessmentId) return null;

  if (type === "work_preparation") {
    return `/arbetsberedning/${projectId}/${folderId}?id=${encodeURIComponent(assessmentId)}`;
  }

  const isSkr =
    type === "skr_assessment" ||
    assessmentId.startsWith("skr_") ||
    assessmentId.startsWith("skr_assessment_");

  const basePath = isSkr ? "/skr-bedomning" : "/riskbedomning";

  const params = new URLSearchParams({
    projektId: projectId,
    folderId,
    assessmentId,
    startAtSteg3: "true",
  });

  return `${basePath}?${params.toString()}`;
}
